import * as A from '../actions/candidateRegistrationActions';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { Request } = ssCommonUtils;

const init = {
    showPasswordResetModal: false,
    registrationStatus: null,
    stepStatus:  {
        step2: null,
        step3: null,
        step4: null,
        step5: null,
        step6: null
    },
    registrationRequest: new Request()
}

export default (state=init, action) => { switch(action.type) {
    case A.TOGGLE_PASSWORD_RESET_MODAL: 
        return {...state, showPasswordResetModal: !state.showPasswordResetModal };

    case A.CLEAR_CANDIDATE_REGISTRATION_DATA: return {...state, 
        registrationRequest: new Request(),
        registrationStatus: null,
        stepStatus:  {
            step2: null,
            step3: null,
            step4: null,
            step5: null,
            step6: null
        }
    }

    case A.CLEAR_CANDIDATE_REGISTRATION_REQUEST: 
        return {...state, registrationRequest: new Request()};

    case A.UPDATE_REGISTRATION_STEP_STATUS: return ((state, step, status) => {
        let 
        overallStatus,
        stepStatus = {...state.stepStatus, [step]: status };

        for(let s in stepStatus)
            if(stepStatus[s] !== 'success') {
                overallStatus = 'error';
                break;
            }
        
        if(overallStatus == null) overallStatus = 'success';

        return {...state, 
            registrationStatus: overallStatus,
            stepStatus: {...stepStatus}
        };
    })(state, action.payload.step, action.payload.status);

    case A.CANDIDATE_REGISTRATION_SUBMISSION_PENDING: 
        return {...state, registrationRequest: {...state.registrationRequest, status: 'pending' }};

    case A.CANDIDATE_REGISTRATION_SUBMISSION_SUCCESS: 
        return {...state, registrationRequest: {...state.registrationRequest, status: 'success' }};

    case A.CANDIDATE_REGISTRATION_SUBMISSION_FAILURE: 
        return {...state, registrationRequest: {...state.registrationRequest, 
            status: 'failure',
            code: action.payload.status
        }};

    default: return {...state};
}}